<template>
  <!-- modalContents__object04：：会員登録フォーム・その２ -->
  <div class="modalContents__object04">
    <div class="container">
      <div class="row no-gutters">
        <div class="col-xl-6 col-lg-8 col-md-11 col-12 mx-auto">
          <div class="modalContents__object04__btn-ex" v-if="isLogged">
            <a
              href="javascript:void(0)"
              class="globalModal--btn"
              title="close"
              @click="hideModal"
            >
              <span class="fa-stack fa-lg">
                <i class="fa fa-circle-thin fa-stack-2x fa-inverse" aria-hidden="true"></i>
                <i class="fa fa-times fa-stack-1x fa-inverse" aria-hidden="true"></i>
              </span>
            </a>
          </div>
          <h2 class="text-center">PLAN</h2>
          <form id='signup02_form' class="row no-gutters">
            <!-- プラン内容 -->
            <h3 class="col-12">■ 動画視聴プラン内容</h3>
            <div class="col-12 row no-gutters modalContents__object04--plan">
              <div class="col-3 offset-2">
                <h4 class="text-center">当日ライブ視聴</h4>
              </div>
              <div class="col-3">
                <h4 class="text-center">アーカイブ視聴</h4>
              </div>
              <div class="col-4">
                <h4 class="text-center">スペシャル特典</h4>
              </div>
            </div>
            <dl class="col-12 row no-gutters">
              <dt class="col-2 text-center">
                <div>ブロンズ</div>
              </dt>
              <dd class="col-3 text-center">
                <div><em>60分まで</em></div>
              </dd>
              <dd class="col-3 text-center">
                <div>×</div>
              </dd>
              <dd class="col-4 text-center">
                <div>×</div>
              </dd>
              <dt class="col-2 text-center">
                <div>シルバー</div>
              </dt>
              <dd class="col-3 text-center">
                <div>無制限</div>
              </dd>
              <dd class="col-3 text-center">
                <div>月5本まで</div>
              </dd>
              <dd class="col-4 text-center">
                <div>×</div>
              </dd>
              <dt class="col-2 text-center">
                <div>ゴールド</div>
              </dt>
              <dd class="col-3 text-center">
                <div>無制限</div>
              </dd>
              <dd class="col-3 text-center">
                <div>無制限</div>
              </dd>
              <dd class="col-4 text-center">
                <div>×</div>
              </dd>
              <dt class="col-2 text-center">
                <div>プラチナ<br>(サロン)</div>
              </dt>
              <dd class="col-3 text-center">
                <div>無制限</div>
              </dd>
              <dd class="col-3 text-center">
                <div>無制限</div>
              </dd>
              <dd class="col-4">
                <div>● 抽選チケット<br>　 プレゼント<br>● サロン招待<br>● シンポジウム招待<br>● 著書プレゼント<br>　 等</div>
              </dd>
            </dl>
            <p class="col-12 text-left">
              <i>※ブロンズメンバープラン（無料会員）は、当日ライブの放送開始から前半60分のみの視聴が可能です。</i>
            </p>
            <!-- OPED.social_login -->
            <div class="col-12 row no-gutters">
              <p class="oped_plan_message">有料プランへご変更される場合のご注意事項<br><br>
すでにオプエドサービスへご登録が済んでいる場合はご利用されるSNSのメールアドレスが同一でない場合は別アカウントとして有料プランへご登録されます。
なお、LINEの場合は同一のメールアドレスで、ご利用の場合であってもブロンズプランへ新規登録となり別アカウントが作成されますのでご注意が必要です。</p>
            </div>
            <!-- プラン選択 -->
            <h3 class="col-12">■ 動画視聴プラン選択</h3>
            <div class="col-12 row no-gutters modalContents__object04--plan01">
              <div class="col-md-1 col-2">
                <input type="radio" name="plan" id="plan01" value="bronze"  v-model="plan">
                <label for="plan01" aria-hidden="true"></label>
              </div>
              <label class="col-md-11 col-10 row no-gutters" for="plan01">
                <p class="col-8">ブロンズメンバー</p>
                <em class="col-4">無料会員</em>
              </label>
            </div>
            <div class="col-12 row no-gutters modalContents__object04--plan02">
              <div class="col-md-1 col-2">
                <input type="radio" name="plan" id="plan02" value="silver"  v-model="plan">
                <label for="plan02" aria-hidden="true"></label>
              </div>
              <label class="col-md-11 col-10 row no-gutters" for="plan02">
                <p class="col-8">シルバーメンバー</p>
                <em class="col-4">月額 980円</em>
              </label>
            </div>
            <div class="col-12 row no-gutters modalContents__object04--plan03">
              <div class="col-md-1 col-2">
                <input type="radio" name="plan" id="plan03" value="gold"  v-model="plan">
                <label for="plan03" aria-hidden="true"></label>
              </div>
              <label class="col-md-11 col-10 row no-gutters" for="plan03">
                <p class="col-8">ゴールドメンバー</p>
                <em class="col-4">月額 3,980円</em>
              </label>
            </div>
            <div class="col-12 row no-gutters modalContents__object04--plan04">
              <div class="col-md-1 col-2">
                <input type="radio" name="plan" id="plan04" value="platinum"  v-model="plan">
                <label for="plan04" aria-hidden="true"></label>
              </div>
              <label class="col-md-11 col-10 row no-gutters" for="plan04">
                <p class="col-8">プラチナメンバー（サロン）</p>
                <em class="col-4">月額 9,800円</em>
              </label>
            </div>

            <!-- メールマガジン -->
            <h3 class="col-12" v-if="mailmagazine_change">■ メールマガジン「ニッポンの問題点」</h3>
            <div class="col-12 row no-gutters modalContents__object04--mm01" v-if="mailmagazine_change">
              <div class="col-md-1 col-2">
                <input type="checkbox" name="mm01" id="mm01" value="1" v-model='mm01'>
                <label for="mm01" aria-hidden="true"></label>
              </div>
              <label class="col-md-11 col-10 row no-gutters" for="mm01">
                <p class="col-8">「ニッポンの問題点」購読</p>
                <em class="col-4">月額 500円</em>
              </label>
            </div>
            <h3 class="col-12" v-if="mailmagazine_change">■ メールマガジン「読むオプエド」</h3>
            <div class="col-12 row no-gutters modalContents__object04--mm02" v-if="mailmagazine_change">
              <div class="col-md-1 col-2">
                <input type="checkbox" name="mm02" id="mm02" value="1" v-model='mm02'>
                <label for="mm02" aria-hidden="true"></label>
              </div>
              <label class="col-md-11 col-10 row no-gutters" for="mm02" v-if="mailmagazine_change">
                <p class="col-8">「読むオプエド」購読</p>
                <em class="col-4">月額 1,000円</em>
              </label>
            </div>
            <p class="col-12 text-right">
              <i>※表示価格は全て税別です。</i>
            </p>
            <p class="error_message text-danger" v-if='changePlanError'>{{ changePlanError }}</p>

            <div class="col-12 row no-gutters">
              <p class="oped_plan_message">消費増税引き上げに伴う料金変更につきまして<br><br>消費税法により2019年10月1日以降に弊社がご提供するサービス等に係る消費税率は、経過措置又は軽減税率が適用されるものを除き、10％となる予定です。同日前にご請求させていただくご契約については、ご提供期間が2019年10月1日以降に係る部分につきまして消費税率を10％にて計算いたします。<br>
すでに締結済みのご契約につきましては消費税率の10％への引き上げ日以降に、消費税法および締結済みのご契約に基づき、ご提供期間が2019年10月1日以降に係る部分について、新税率10％と旧税率8％との差額を別途（2019年10月以降）ご請求させていただく予定でございます。<br>
なお、消費税率10％への引き上げが行われない場合、すでにご請求させていただきました現行消費税8％との差額をご返金させていただきます。
ご不明な点がございましたら、弊社へお問い合わせください。　<a style="color:#FFF" href="https://op-ed.jp/" target="_blank">https://op-ed.jp/</a></p>
            </div>

            <!-- 戻るボタン -->
            <div class="col-4 modalContents__object04--position01" v-if="!isLogged">
              <button class="text-center btn modalContents__object04--back globalModal--btn" @click="back">戻る</button>
            </div>
            <!-- 次へボタン -->
            <div class="col-6 offset-2">
              <button id="signup02_btn" class="text-center btn globalModal--btn" @click="next">次へ</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .error_message{
    font-size: 85%;
    padding-top: 6px;
    margin-bottom: 0;
  }
</style>

<script>
  import { mapActions } from 'vuex'
  import MultiModalMixin from '../mixins/ModalMixin'

  export default {
    name: 'plan',
    data : function(){
      let data = {};
      
      data.mailmagazine_change = true;

      if(OPED.isLogged){
        //OPED.login_user.plan_class
        data.plan = this.getUserPlanName();

        if(!OPED.login_user.email){
          data.mailmagazine_change = false;
        }
      }else{
        data.plan = this.$store.state.inputData.plan ? this.$store.state.inputData.plan : 'bronze';
      }

      if(OPED.isLogged){
        data.mm01 = this.$store.state.userData.mm01;
      }else{
        data.mm01 = this.$store.state.inputData.mm01 ? this.$store.state.inputData.mm01 : '';
      }

      if(OPED.isLogged){
        data.mm02 = this.$store.state.userData.mm02;
      }else{
        data.mm02 = this.$store.state.inputData.mm02 ? this.$store.state.inputData.mm02 : '';
      }

      return {
        ...data,
        changePlanError : '',
        isLogged: OPED.isLogged
      }
    },
    mixins: [MultiModalMixin],
    methods : {
      back (e) {
        this.showModalMain();
        e.preventDefault();
      },
      next (e) {

        this.$store.state.inputData.plan = this.plan;
        this.$store.state.inputData.mm01 = this.mm01;
        this.$store.state.inputData.mm02 = this.mm02;

        if(!this.isLogged){
          if(this.plan == 'bronze' && !this.mm01 && !this.mm02){
            this.showModalRegistConfirm();
          }else{
            this.showModalPayment();
          }
        }else{
          this.changePlanError = '';

          // // 同プラン変更についての処理を外した　2019/01/06
          // if(this.plan == 'bronze' && !this.mm01){
          //   this.showModalEditPlanConfirm();
          // }else{
          //   this.showModalPayment();
          // }
          
          //if(OPED.new_order.created_at)
          if(OPED.login_user){
            if(OPED.login_user.new_order){
              var created = OPED.login_user.new_order.created_at.split('-').join('/');
              var now = OPED.now.split('-').join('/');
              var createdDate = new Date(created);
              var nowDate = new Date(now);
              var createdStr = createdDate.getFullYear() + '-' + createdDate.getMonth();
              var nowStr = nowDate.getFullYear() + '-' + nowDate.getMonth();
              if(createdStr == nowStr){
                if(this.getUserPlanName() == this.plan){
                  this.changePlanError = '今月は、同プランへの変更はできません。';
                }
              }
            }
          }
          if(!this.changePlanError){
            if(this.plan == 'bronze' && !this.mm01 && !this.mm02){
              this.showModalEditPlanConfirm();
            }else{
              this.showModalPayment();
            }
          }

          // if(this.getUserPlanName() == this.plan && this.$store.state.userData.mm01 == this.$store.state.inputData.mm01){
          //   this.changePlanError = 'プランの変更がありません。再度ご確認ください。';
          // }else{
          //   if(this.plan == 'bronze' && this.mm01 == ''){
          //     this.showModalEditPlanConfirm();
          //   }else{
          //     this.showModalPayment();
          //   }
          // }
        }

        e.preventDefault();
      },
      getUserPlanName(){
        if(this.$store.state.userData.plan == 0){
          return 'bronze';
        }
        if(this.$store.state.userData.plan == 1){
          return 'silver';
        }
        if(this.$store.state.userData.plan == 2){
          return 'gold';
        }
        if(this.$store.state.userData.plan == 3){
          return 'platinum';
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .oped_plan_message{
    font-style: normal;
    color: #fff;
    font-size: 82%;
    display: block;
    line-height: 1.5;
    padding: 10px;
    border: solid #fff 1px;
    border-radius: 5px;
    background-color: #212121;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/vue/component/modal/plan.vue